import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@efexteam/components';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PasswordResetModalStyles from './PasswordResetModal.styles';
import { PasswordResetModalProps } from './PasswordResetModal.types';
import { usePasswordResetModal } from './hooks/usePasswordResetModal';

const PasswordResetModal = ({
  open,
  onClose,
  userEmail,
  onPasswordResetSent,
  successTimeout = 2000,
}: PasswordResetModalProps) => {
  const { t } = useTranslation();

  const {
    isLoading,
    handleResetPassword: resetPassword,
    handleClose,
    buttonText,
  } = usePasswordResetModal({
    successTimeout,
    onPasswordResetSent,
    onClose,
  });

  const handleResetPassword = () => resetPassword(userEmail);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle showCloseButton onClick={handleClose}>
        <Box className={PasswordResetModalStyles.iconContainer}>
          <Box className={PasswordResetModalStyles.iconWrapper}>
            <LockOutlinedIcon className={PasswordResetModalStyles.icon} />
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent className={PasswordResetModalStyles.dialogBody}>
        <Typography
          variant="h5"
          className={PasswordResetModalStyles.title}
          gutterBottom
          id="password-reset-title"
        >
          {t('passwordExpired') || ''}
        </Typography>

        <Typography
          variant="body1"
          className={PasswordResetModalStyles.description}
          gutterBottom
          id="password-reset-description"
        >
          {t('passwordExpiredDescription') || ''}
        </Typography>

        <Box className={PasswordResetModalStyles.buttonContainer}>
          <Button
            appearance="primary"
            size="large"
            onClick={handleResetPassword}
            disabled={isLoading}
          >
            {buttonText}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PasswordResetModal;
